// extracted by mini-css-extract-plugin
export var animateCircle = "cookie-banner-module--animate-circle--Taqd1";
export var bounce = "cookie-banner-module--bounce--KFt7-";
export var btnClose = "cookie-banner-module--btnClose--k-oF1";
export var button = "cookie-banner-module--button--8j5Cq";
export var closeBtn = "cookie-banner-module--close-btn--4Je0p";
export var cookieBanner = "cookie-banner-module--cookieBanner--lUnMi";
export var cross = "cookie-banner-module--cross--TMBGn";
export var ldsRing = "cookie-banner-module--lds-ring--XL5xv";
export var subtitle = "cookie-banner-module--subtitle--D9yn2";
export var title = "cookie-banner-module--title--qoHA1";